import script from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=3fbfdb0d&lang=scss"

const __exports__ = script;

export default __exports__